import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * The button for an embedded AI action, such as the AI Program Check. It looks different from every
 * other button on purpose (Jeff, 2026-11-04: "this is embedded AI - so the button has to be special"):
 * an indigo-to-violet gradient, the wand-and-sparkles icon, a violet glow, and a light sweep on hover.
 * While the AI works it shows a spinner and does not take a second click.
 *
 *   <prox-ai-button label="AI Program Check" [fullWidth]="true" (clicked)="onCheck()"></prox-ai-button>
 */
@Component({
  selector: 'prox-ai-button',
  standalone: true,
  template: `
    <button
      type="button"
      class="group relative inline-flex items-center justify-center gap-2 overflow-hidden rounded-md bg-gradient-to-r from-indigo-600 to-violet-600 px-4 py-2 text-sm font-semibold text-white shadow-lg shadow-violet-500/40 transition-shadow hover:shadow-violet-500/70 disabled:cursor-not-allowed disabled:opacity-60"
      [class.w-full]="fullWidth"
      [disabled]="disabled || loading"
      [attr.title]="tooltip || null"
      (click)="clicked.emit()"
    >
      <span
        class="pointer-events-none absolute inset-y-0 -left-1/2 w-1/3 -skew-x-12 bg-gradient-to-r from-transparent via-white/40 to-transparent transition-transform duration-700 ease-out group-hover:translate-x-[450%]"
      ></span>
      <i [class]="loading ? 'fa-solid fa-spinner fa-spin' : 'fa-solid fa-wand-magic-sparkles'"></i>
      <span>{{ label }}</span>
    </button>
  `,
})
export class AiButtonComponent {
  @Input() label = 'AI';
  @Input() tooltip?: string;
  @Input() fullWidth = false;
  @Input() disabled = false;
  @Input() loading = false;
  @Output() clicked = new EventEmitter<void>();
}
